import React, {memo} from "../../../../../__snowpack__/pkg/react.js";
import {Row, Col} from "../../../../../__snowpack__/pkg/antd.js";
const FormItemLayout = memo((props) => {
  const {label = "", children = null, style = {}, span = 2, bodyStyle = {}} = props;
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span,
    style: {maxWidth: "100px", minWidth: "80px", lineHeight: "22px", color: "#899BB5", ...style}
  }, label), /* @__PURE__ */ React.createElement(Col, {
    span: 22,
    style: {...bodyStyle}
  }, children ?? null));
});
export default FormItemLayout;
